import { ActionExtended } from '../../_config/interfaces'

export interface AdminReducer {
    existingUsers: any
    pendingUsers: any
}

const initialState: AdminReducer = {
    existingUsers: [],
    pendingUsers: [],
}

const adminReducer = (state = initialState, action: ActionExtended) => {
    return state
}

export default adminReducer
